import * as React from "react";
import PropTypes from "prop-types";
import {
  gridPageCountSelector,
  GridPagination,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

import MuiPagination from "@mui/material/Pagination";

function CustomPagination({ page, onPageChange, className }) {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <MuiPagination
      color="primary"
      className={className}
      count={pageCount}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(event, newPage - 1);
      }}
    />
  );
}

CustomPagination.propTypes = {
  className: PropTypes.string,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
};

export default function CustomDataGridPagination(props) {
  return <GridPagination ActionsComponent={CustomPagination} {...props} />;
}
